import { render, staticRenderFns } from "./procedures-editor-info.vue?vue&type=template&id=7f50b372"
import script from "./procedures-editor-info.vue?vue&type=script&lang=js"
export * from "./procedures-editor-info.vue?vue&type=script&lang=js"
import style0 from "./procedures-editor-info.vue?vue&type=style&index=0&id=7f50b372&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports